/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Alert.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var singleClassComponent_1 = require("./util/singleClassComponent");
var flattenArray_1 = require("./util/flattenArray");
var uniqueArray_1 = require("./util/uniqueArray");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-alert");
exports.AlertSizesArray = ["small", "medium", "large"];
exports.AlertTypesArray = [
    "success",
    "info",
    "warning",
    "offline",
    "error"
];
exports.AlertOverarchingTypesArray = [
    "info",
    "warning",
    "offline",
    "error"
];
exports.AlertTypeIconMap = {
    success: "alert-success-small",
    info: "alert-info-small",
    warning: "alert-warning-small",
    offline: "alert-connection-lost-small",
    error: "alert-error-small"
};
var getTypeFromIconName = function (iconName) {
    return iconName.match(/alert-([^-.]*)/)[1];
};
exports.Alert = function Alert(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.type, type = _c === void 0 ? "success" : _c, floating = _a.floating, children = _a.children, linkText = _a.linkText, onLinkClick = _a.onLinkClick, props = tslib_1.__rest(_a, ["className", "size", "type", "floating", "children", "linkText", "onLinkClick"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), size), propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), type), floating && moduleClassName("isFloating"), className) }, props),
        React.createElement("div", { className: moduleClassName("content") },
            React.createElement(Icon_1.Icon, { type: exports.AlertTypeIconMap[type], className: moduleClassName("icon") }),
            children),
        !!onLinkClick && (React.createElement("button", { className: classnames(moduleClassName("link"), !!linkText && moduleClassName("link-isText")), onClick: onLinkClick }, !linkText ? React.createElement(Icon_1.Icon, { type: "close-small" }) : linkText))));
};
exports.Alert.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(exports.AlertSizesArray),
    type: PropTypes.oneOf(uniqueArray_1.uniqueArray(flattenArray_1.flattenArray(exports.AlertTypesArray, exports.AlertOverarchingTypesArray))),
    linkText: PropTypes.node,
    onLinkClick: PropTypes.func
};
exports.AlertTitle = singleClassComponent_1.singleClassComponent("AlertTitle", moduleClassName("title"));
exports.AlertMessage = singleClassComponent_1.singleClassComponent("AlertMessage", moduleClassName("message"));
exports.AlertActions = singleClassComponent_1.singleClassComponent("AlertActions", moduleClassName("actions"));
exports.AlertAction = function AlertAction(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement("a", tslib_1.__assign({ className: classnames(moduleClassName("action"), className) }, props)));
};
exports.OverarchingAlert = function OverarchingAlert(_a) {
    var blocking = _a.blocking, className = _a.className, size = _a.size, props = tslib_1.__rest(_a, ["blocking", "className", "size"]);
    return (React.createElement(exports.Alert, tslib_1.__assign({ size: "large", className: classnames(moduleClassName("isOverarching"), blocking && moduleClassName("isBlocking"), className) }, props)));
};
exports.OverarchingAlert.propTypes = tslib_1.__assign({}, exports.Alert.propTypes, { blocking: PropTypes.bool });